export function reverse(viewName, args) {
    if(viewName in urls_mapping) {
        return urls_mapping[viewName](args)
    } else {
        throw new Error('Could not find a reverse for view name "' + viewName + '".')
    }
}

// Maintain this urls mapping object for url reversing on js components
const urls_mapping = {
    'selected_framework': function (args) { return '/ac/' + args[0] + '/framework' },
    'framework_by_dimension': function (args) { return '/api/internal/editor/framework_by_dimension/' + args[0] + '/' },
    'cloned_item_edit': function (args) { return '/item/' + args[0] + '/apiedit/' + '#successClone'},
    'metadata_prefixes': function () { return '/api/internal/harvester_configuration/metadata_prefixes/'},
    'namespace_details': function (args) { return '/api/internal/identifiers/namespace/' + args[0]},
    'create_propose_changes': function () { return '/api/v4/issues/proposed-changes'},
    'edit_propose_changes': function (args) { return '/api/v4/issues/proposed-changes/' + args[0] + '/'},
    'get_identifer_name': function (args) {return '/api/internal/names/' + args[0] + '/issue-name/'},
    'reroute_issues_tab_path': function (args) { return  args[0] + '/issues/'},
    'edit_issue_endpoint': function (args) {return '/api/v4/issues/' + args[0] + '/' },
    'update_pipeline_config': function (args) { return '/api/activate/pipeline/' + args[0] + '/update' },
    'stewardship_inventory_card': function (args) { return '/steward/' + args[0] + '/inventory/' + args[1] + '/card' },
    'inventory_card': function (args) { return '/inventory/' + args[0] + '/card' },
    'stewardship_inventory_list': function (args) { return '/steward/' + args[0] + '/inventory/' + args[1] + '/list' },
    'inventory_list': function (args) { return '/inventory/' + args[0] + '/list' },
    'editor_dataset': function (args) { return '/api/internal/editor/metadata/dataset/' + args[0] },
    'metadata_dataelement': function (args) { return '/api/v4/metadata/dataelement/' + args[0] },
    'editor_distribution': function (args) { return '/api/internal/editor/metadata/distribution/' + args[0] },
    'manage_additional_access': function (args) { return '/action/additional_access/' + args[0] + '/' },
    'so_workgroup_autocomplete': function (args) { return '/ac/' + args[0] + '/workgroup' },
    'metadata_item_templates': function (args) { return '/ac/metadata_item_templates/' + args[0] + '/' + args[1] },
}
